<template>
  <ValidationObserver ref="form" tag="div" v-slot="{ errors, failed }">
    <transition name="fade">
      <NotificationMessage :messages="errors" v-if="failed"></NotificationMessage>
    </transition>
    <AGCInput v-model.trim="inputVal.companyName"
              name="公司/集團名稱"
              label="公司/集團名稱"
              class="mb-3"
              placeholder="公司/集團名稱"
              rules="required|max:50"
              required
    ></AGCInput>
    <AGCInput v-model="inputVal.name"
              name="商戶/網店名稱"
              label="商戶/網店名稱"
              sub-label="(顯示於U Lifestyle App 及 U Lifestyle網頁，建議長度30字之内)"
              class="mb-3"
              placeholder="商戶/網店名稱"
              rules="required|max:50"
              required
    ></AGCInput>
    <div class="agc-brc__wrapper">
      <AGCBusinessRegistrationCertificate
        name="商業登記號碼"
        label="商業登記號碼"
        v-model="inputVal.brc"
        class="mb-3"
        rules="required|brc"
        required
      >
        <template v-slot:subLabel>
          <span>
            (請輸入16位商業登記號碼，如未能提供，請聯絡
            <a href="mailto:eCoupon@ulifestyle.com.hk">eCoupon@ulifestyle.com.hk</a>)
          </span>
        </template>
      </AGCBusinessRegistrationCertificate>
    </div>
    <DropZone
      v-model="inputVal.brcImage"
      :max-files="1"
      acceptedFiles=".jpg,.jpeg,.png,.pdf"
      rules="required"
      name="商業登記證"
      label="商業登記證"
      sub-label="(檔案大小上限2mb，建議尺寸 640x480 px)"
      class="mb-3 merchant-brc-image"
      upload-type="merchantBrc"
      public-api
      required
    >
      <template v-slot:subLabel>
        <span>
          (如未能提供，請聯絡
          <a href="mailto:eCoupon@ulifestyle.com.hk">eCoupon@ulifestyle.com.hk</a>)
        </span>
      </template>
      <template v-slot:hint>
        <span>只支援JPG/PNG/PDF檔</span>
      </template>
    </DropZone>
    <DropZone
      v-model="inputVal.logo"
      :max-files="1"
      rules="required"
      name="品牌標誌"
      :acceptedAspectRatios="['1:1']"
      label="品牌標誌"
      sub-label="(只可上傳 1:1 圖片，檔案大小上限2mb，尺寸1080x1080 px)"
      class="mb-3 merchant-logo"
      upload-type="merchantLogo"
      public-api
      required
    ></DropZone>
    <AGCInput v-model="inputVal.email"
              name="公司電郵"
              label="公司電郵"
              sub-label="(作登入《社群》帳戶及公開展示於App內供會員查閱之用)"
              class="mb-3"
              placeholder="公司電郵"
              rules="required|email"
              required
    ></AGCInput>
    <AGCInput v-model="inputVal.hotline"
              name="公司聯絡電話"
              label="公司聯絡電話"
              class="mb-3"
              placeholder="公司聯絡電話"
              rules="numeric|min:6|max:12"

    >
        <template v-slot:subLabel v-if="inputVal.isUseWhatsApp">
        <span>
          (只限Whatsapp聯絡)
        </span>
      </template>
    </AGCInput>
    <AGCCheckbox v-model="inputVal.isUseWhatsApp"
                 class="mb-3"
    >
      <span>
        只限Whatsapp聯絡
      </span>
    </AGCCheckbox>

    <AGCInput v-model="inputVal.address"
              name="公司地址"
              label="公司地址"
              class="mb-3"
              placeholder="公司地址"
              rules="max:150"
    ></AGCInput>
    <AGCInput v-model="inputVal.website"
              name="公司網頁"
              label="公司網頁"
              class="mb-3"
              placeholder="公司網頁"
              rules="url"
    ></AGCInput>
    <AGCInput v-model="inputVal.facebook"
              name="Facebook"
              label="公司社交媒體"
              class="mb-3"
              placeholder="Facebook"
              rules="url"
    ></AGCInput>
    <AGCInput v-model="inputVal.instagram"
              name="Instagram"
              class="mb-3"
              placeholder="Instagram"
              rules="url"
    ></AGCInput>
    <div class="agc-textarea__wrapper">
      <CompanyIntroTemplateContentEditor
        label="公司簡介"
        sub-label="(公司簡介最多為 500 個全形字)"
        v-model="inputVal.desc"
        :is-show-select="true"
      ></CompanyIntroTemplateContentEditor>
    </div>
    <TagAndSubTagsList
      v-model="inputVal.tags"
      label="業務性質"
      sub-label="(最多可選兩項)"
      required
      :tag-options="merchantTagOptions"
      :sub-tag-options="merchantSubTagOptions"
    ></TagAndSubTagsList>
    <AGCRadioGroup v-model="inputVal.shopType"
                   :options="shopTypes"
                   name="店鋪類型"
                   label="店鋪類型"
                   class="mb-3"
                   rules="required"
                   required
    ></AGCRadioGroup>
    <DropZone
      v-model="inputVal.banner"
      :max-files="1"
      name="宣傳圖片"
      label="宣傳圖片"
      rules="required"
      sub-label="(展示U Lifestyle App 及 U Lifestyle《社群》網頁之品牌專頁，檔案大小上限2mb，建議尺寸 1200x676px)"
      class="mb-3"
      upload-type="merchantBanner"
      public-api
      required
    ></DropZone>
    <DropZone
      v-model="inputVal.images"
      :max-files="3"
      rules="required"
      name="圖片集"
      class="mb-3"
      upload-type="merchantImages"
      label="圖片集"
      id="images"
      sub-label="(最多3張，展示於U Lifestyle App《U Jetso》頁面，每張建議上限2mb，尺寸 600x600px)"
      public-api
      required
    ></DropZone>
    <AGCRadioGroup v-model="inputVal.accTypeInRegister"
                   :options="accTypes"
                   name="申請商戶帳戶類型"
                   label="申請商戶帳戶類型"
                   class="mb-3"
                   rules="required"
                   required
    ></AGCRadioGroup>
  </ValidationObserver>
</template>

<script>
import formMixin from '@/mixins/form';
import vModelMixin from '@/mixins/v-model';
import wordCount from '@/filters/word-count';
import imagePath from '@/filters/image-path';
import AGCInput from '@/components/form/AGCInput.vue';
import AGCRadioGroup from '@/components/form/AGCRadioGroup.vue';
import AGCBusinessRegistrationCertificate from '@/components/form/AGCBusinessRegistrationCertificate.vue';
import DropZone from '@/components/form/DropZone.vue';
import AGCCheckbox from '@/components/form/AGCCheckbox.vue';
import NotificationMessage from '@/components/NotificationMessage.vue';
import CompanyIntroTemplateContentEditor from '@/components/form/company-intro-template/ContentEditor.vue';
import TagAndSubTagsList from '@/components/merchant/TagAndSubTagsList.vue';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    AGCInput,
    AGCRadioGroup,
    AGCBusinessRegistrationCertificate,
    CompanyIntroTemplateContentEditor,
    DropZone,
    TagAndSubTagsList,
    AGCCheckbox,
    NotificationMessage,
  },
  props: {
    merchantTagOptions: {
      type: Array,
    },
    merchantSubTagOptions: {
      type: Object,
    },
  },
  data: () => ({
    shopTypes: [
      { text: '實體商店', value: 'physical' },
      { text: '網上商店', value: 'internet' },
      { text: '實體店及網店', value: 'both' },
    ],
    accTypes: [
      { text: '普通商戶(只供上載積分優惠券)', value: 'NORMAL' },
      { text: '星級商戶(可上載付費優惠券及積分優惠券)', value: 'PREMIUM' },
    ],
    isUseWhatsAppOption: [
      { name: '是', id: 1 },
    ],
  }),
  filters: {
    wordCount,
    imagePath,
  },
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style scoped lang="scss">
.agc-textarea {
  &__wrapper {
    position: relative;
    ::v-deep {
      textarea {
        min-height: 160px;
      }
    }
  }

  &__counter {
    position: absolute;
    top: 100%;
    right: 0;
    font-size: 14px;
    color: #636d77;
  }
}

.agc-brc {
  &__wrapper {
    ::v-deep {
      input {
        &:nth-child(1) {
          width: 6rem;
        }
        &:nth-child(3) {
          width: 3.5rem;
        }
        &:nth-child(5) {
          width: 3rem;
        }
        &:nth-child(7) {
          width: 3rem;
        }
        &:nth-child(9) {
          width: 2.5rem;
        }
      }
    }
  }
}

.merchant {
  &-brc-image,
  &-logo {
    ::v-deep {
      .dropzone {
        width: 162px;

        .dz-preview {
          margin: 16px -12px;
        }
      }
      .thumbnail-preview-item {
        margin: 8px 0;
      }
    }
  }
}
</style>
